const Checkbox = (props) => {
    return (
        <>
            <input name={props.name} className="form-check-input" type="checkbox" defaultChecked={props.value} id={props.id} readOnly={props.readOnly} required={props.required} />
            <label htmlFor={props.id}>{props.title} {props.value}</label>
        </>
    )
}


export default Checkbox;